<template>
  <div class="coupon-detail">
    <!-- 轮播图区域 -->
    <div class="banner-section">
      <van-swipe class="banner-swipe" :autoplay="10000" indicator-color="white">
        <van-swipe-item v-for="(item, index) in bannerList" :key="index">
          <van-image :src="item" fit="cover" class="banner-image" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 商品信息区域 -->
    <div class="info-section">
      <!-- 价格区域 -->
      <div class="price-section">
        <div class="price">
          <span class="price-value">{{ selectPrice }}</span>
          <span class="price-unit">点</span>
        </div>
        <div class="title-tag" v-if="getTitleTag()" :style="{ background: getTitleTag().colorCode }">
          {{ getTitleTag().name }}
        </div>
      </div>

      <!-- 商品名称 -->
      <div class="product-name">
        <span class="name">{{ showProductName }}</span>
      </div>

      <!-- 标签列表 -->
      <div class="tag-list">
        <span class="tag-item" v-for="(val, index) in getTagList()" :key="index">
          {{ val.name }}
        </span>
      </div>
    </div>

    <!-- 商品详情区域 -->
    <div class="detail-section">
      <div class="section-header">
        <div class="header-line"></div>
        <span class="header-text">商品详情</span>
      </div>
      
      <!-- 商品描述 -->
      <div class="description" v-html="detail?.description"></div>
      
      <!-- 商品图片列表 -->
      <div class="image-list">
        <van-image 
          v-for="(item, index) in goodsDetailImgList" 
          :key="index" 
          :src="item"
          class="detail-image"
        />
      </div>

    </div>

    <!-- 底部操作栏 -->
    <van-goods-action>
      <van-goods-action-icon icon="cart-o" text="购物车" @click="goCar" />
      <van-goods-action-button 
        type="danger" 
        text="立即购买"
        @click="() => specPopupOpen()" 
      />
    </van-goods-action>

    <!-- 规格选择弹窗 -->
    <SpecPopupDsCardCoupons 
      ref="SpecPopupDsCardCoupons" 
      v-if="productDetaiLoad" 
      :list="specsList" 
      :query-form="detailform"
      @submit="handleSpecSubmit"
    />
  </div>
</template>

<script>
import SpecPopupDsCardCoupons from "../../components/SpecPopup/SpecPopupDsCardCoupons.vue";
import OverlayLoad from "../../components/SpecPopup/OverlayLoad.vue";
import { goMyCart, getGoodsDetail, submitBuyGoodsInfo } from "./index.action";
import Utils from "../../utils";
export default {
  name: "DetailsDsCardCoupons",
  props: {},
  data() {
    return {
      goodsDetailImgList: [], // 商品详情数组
      bannerList: [], // banner图
      specsList: [], // 可选规格列表
      loading: false,
      productDetaiLoad: false, // 详情信息,是否加载完成
      detail: null,
      bannerHeight: 0,
      //商品规格
      show: false,
      sendTypeStr: "", // 展示的配送信息
      detailform: {
        cardId: "",
        cityCode: "",
        brandId: "",
        productId: ""
      },

      userId: "",
      selectPrice: '',
      selectMarketprice: "",
      goodNum: 1, // 商品数量
      specId: this.$route.query.specId, // 规格 id
      shopId: "",
      shopName: "",
      consigneeName: "",
      consigneePhone: "",
      productType: "",
      delivery_amount: "0",
      showProductName: "",
    };
  },
  components: { 
    SpecPopupDsCardCoupons,
    OverlayLoad 
  },

  mounted() {
    this.init();
    this.bannerHeight = (document.body.clientWidth || window.innerWidth || document.documentElement.clientWidth)
    var timer = setInterval(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0
      clearInterval(timer);
    }, 200)
  },

  computed: {
  },

  methods: {
    goBack() {
      this.$router.back();
    },
    getTitleTag() {
      let Tag = undefined
      if (this.detail?.labelList) {
        this.detail?.labelList.forEach(element => {
          if (element.smallLabelType == '1') {
            Tag = element
          }
        });
      }
      return Tag
    },
    getTagList() {
      let Tag = []
      if (this.detail?.labelList) {
        this.detail?.labelList.forEach(element => {
          if (element.smallLabelType !== '1') {
            Tag.push(element)
          }
        });
      }
      return Tag
    },
    formNumber(val) {
      if (val) {
        return parseFloat(val).toFixed(2)
      } else return ''

    },
    init() {
      this.userId = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).id : "";
      this.detailform.cardId = localStorage.getItem("cardId");
      this.detailform.cityCode = localStorage.getItem("cityCode");
      this.detailform.productId = this.$route.query.id;
      this.detailform.brandId = this.$route.query.brandId;
      this.getProductDetail();
    },
    // 获取商品详情
    async getProductDetail() {
      this.loading = true;
      const goodsData = await getGoodsDetail(this.detailform, this.specId);
      this.productDetaiLoad = true;
      if (goodsData) {
        this.detail = goodsData.target;
        this.productType = this.detail.productType
        if (this.detail.venueList && this.detail.venueList.length > 0) {
          this.detail.venueList[0].checked = true
        }
        this.specsList = goodsData.specsArr;
        // 补充商品名称 和 商品规格
        if (this.detail && this.detail.productName && Array.isArray(this.specsList)) {
          this.specsList.forEach(item => {
            item.productName = this.detail.productName;
          });
          const selectedSpec = this.specsList[0];
          this.showProductName = selectedSpec?.productName + (selectedSpec?.specifications || '')
        }
        this.setGoodsInfo(goodsData.defaultSpecs);
      } else {
        var timer = setInterval(() => {
          this.$router.back();
          clearInterval(timer);
        }, 1000)
      }
      this.loading = false;
    },
    // 去购物车
    goCar() {
      goMyCart(2);
    },
    /**
     * 打开规格选择内容页
     */
    specPopupOpen(params) {
      this.$refs.SpecPopupDsCardCoupons.open(params);
    },
    /**
     * 规格菜单点击加入【立即购买】执行函数
     */
    async handleSpecSubmit({ type, selectedSpec, deliveryData }) {
      this.setGoodsInfo(selectedSpec, selectedSpec.count);
      this.loading = true;
      await submitBuyGoodsInfo(
        type,
        { userId: this.userId, ...this.detailform },
        deliveryData,
        selectedSpec,
        this.detail,
      );
      this.loading = false;
    },
    /**
     * 商品相关的data数据回填
     */
    setGoodsInfo(specInfo, count = 1) {
      const specInfo_ = specInfo || {};
      const { id, specifications, showPrice, ticketPrice, bannerList, coverImage, htmEditorList } = specInfo_;
      this.goodNum = count; // 购买数量
      this.specId = id || "";
      this.selectPrice = showPrice || "暂无价格";
      this.setBannerList(coverImage, bannerList, htmEditorList);
    },
    /**
     * 将规格图片推到banner图的主位上
     */
    setBannerList(specsImg, bannerList, htmEditorList) {
      // if (!specsImg) return;
      this.bannerList = Utils.isNoEmptyArr(bannerList) ? [specsImg, ...bannerList] : [specsImg];
      this.goodsDetailImgList = htmEditorList
    }
  },
};
</script>

<style lang="scss" scoped>
.coupon-detail {
  background: #f8f8f8;
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  padding-bottom: 60px; // 为底部操作栏留出空间

  .banner-section {
    width: 100%;
    height: 100vw;
    position: relative;
    background: #fff;
    flex-shrink: 0;
    
    .banner-swipe {
      width: 100%;
      height: 100%;
    }

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info-section {
    background: #fff;
    padding: 16px;
    margin-bottom: 8px;
    flex-shrink: 0;

    .price-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;

      .price {
        .price-value {
          font-size: 28px;
          font-weight: 600;
          color: #D23B2E;
          font-family: DIN;
        }
        .price-unit {
          font-size: 14px;
          color: #D23B2E;
          margin-left: 2px;
        }
      }

      .title-tag {
        padding: 4px 8px;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        font-weight: 500;
      }
    }

    .product-name {
      margin-bottom: 12px;
      line-height: 1.4;

      .name {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .tag-item {
        padding: 4px 8px;
        background: #f5f5f5;
        border-radius: 4px;
        font-size: 12px;
        color: #666;
      }
    }
  }

  .detail-section {
    background: #fff;
    padding: 16px;
    flex: 1;

    .section-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .header-line {
        width: 3px;
        height: 16px;
        background: #D23B2E;
        margin-right: 8px;
        border-radius: 2px;
      }

      .header-text {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }

    .description {
      font-size: 15px;
      color: #333;
      line-height: 1.7;
      margin-bottom: 20px;
      white-space: pre-wrap;
      word-break: break-word;

      :deep(p) {
        margin: 10px 0;
        font-size: 15px;
        line-height: 1.7;
        color: #333;
      }

      :deep(br) {
        content: "";
        display: block;
        margin: 8px 0;
      }

      :deep(img) {
        max-width: 100%;
        height: auto;
        margin: 10px 0;
        border-radius: 4px;
      }

      :deep(strong) {
        font-weight: 600;
        color: #222;
        font-size: 15px;
      }

      :deep(ul), :deep(ol) {
        padding-left: 20px;
        margin: 10px 0;
      }

      :deep(li) {
        margin: 5px 0;
        font-size: 15px;
        line-height: 1.7;
        color: #333;
      }
    }

    .image-list {
      .detail-image {
        width: 100%;
        margin-bottom: 8px;
        border-radius: 4px;
      }
    }

  }
}

// 底部操作栏样式优化
:deep(.van-goods-action) {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  
  .van-goods-action-button {
    height: 40px;
    font-size: 15px;
  }
}
</style>
